import React, {useContext, memo} from 'react';
import {graphql, StaticQuery} from 'gatsby';

// contexts
import LocaleContext from '../../LocaleContext';

// helpers
import {getLocalizedPropertyByPrefix} from '../../helpers/localeHelpers';

// components
import LocalizedLink from '../LocalizedLink/LocalizedLink';
import logo from './images/c9-circle.svg';

// styles
import './footer.scss';

const Footer = () => {
    const { locale } = useContext(LocaleContext);
    return (
        <StaticQuery
            query={graphql`
        query FooterQuery {
            allContentfulMicrocopyPages {
                nodes {
                    footerSlogan
                    language
                }
            }
          contentfulMenu(type: { eq: "Main Menu" }) {
            menuItem {
              id
              svLinkTitle
              enLinkTitle
              fiLinkTitle
              slug
            }
          }
        }
        `}
            render={data => {
                const microcopyPage = data.allContentfulMicrocopyPages.nodes.filter(page => page?.language === locale)[0];
                const { footerSlogan } = microcopyPage;

                const mainMenu = data.contentfulMenu;
                return (
                    <div className="footer">
                        <ul>
                            {mainMenu.menuItem.map(item => (
                                <li key={item.slug}>
                                    <LocalizedLink to={item.slug}>{ getLocalizedPropertyByPrefix(item, 'LinkTitle', locale) }</LocalizedLink>
                                </li>
                            ))}
                        </ul>
                        <div className="footer__bottom">
                            <div className="footer__logo">
                                <img src={logo} alt="logo"/>
                            </div>
                            <span className="footer__slogan">
                {footerSlogan}
              </span>
                        </div>

                    </div>
                )
            }}
        />
    );
}

export default memo(Footer);
